module.exports = __webpack_public_path__ + "img/deleteButton.73473d6b.svg";